// @flow

/**
 * Custom Tags Context
 * Provides tag registry and prompt submission callback for custom tag rendering
 */

import { createContext } from 'react';
import type { CustomTagConfig } from '../types';

export type CustomTagsContextValue = {
  /** Registry of custom tags to render */
  tags: CustomTagConfig[],
  /** Callback to submit a prompt (used by PromptButton) */
  submitPrompt: ((prompt: string) => void) | null,
  /** Whether the chat is currently streaming (buttons should be disabled) */
  isStreaming: boolean,
  /** Additional disabled state for prompt buttons (e.g., report loading) */
  promptButtonsDisabled: boolean,
};

export const CustomTagsContext = createContext<?CustomTagsContextValue>(null);
